import { baseCommand } from './basecommand';

type changematerialTypename = "change_material";
export type materialDatatype = {
    "name" : string;
    "value" : string;
}
type materials = {
    "material" : materialDatatype[]
}

type pscommand<T> = {
    "type": T extends changematerialTypename ? T : never;
    "data": T extends changematerialTypename ? materials : never;
};

export type changematerialCommand = pscommand<changematerialTypename>;

export class changematerial extends baseCommand {
    public type: changematerialTypename = "change_material";

    constructor(private materialdata: materialDatatype[]) {
        super();
    }

    public object(): changematerialCommand {

        const data = { 'material': this.materialdata };

        return {
            "type" : this.type,
            "data" : data
        }
    }

}
